<template>
    <div class="card-box">
        <h4 class="header-title m-t-0 m-b-20 text-dark">{{ $t('follow_ups') }}</h4>
        <div style="min-height: 280px;" v-pml-block="isLoading">
            <div style="height: 280px;" ref="followUps" v-show="hasRegistry"></div>
            <pml-ec-line style="min-height: 280px;" v-if="!hasRegistry"></pml-ec-line>
        </div>
    </div>
</template>

<script>
    import c3 from 'c3'
    import { getFollowUps } from 'services/dashboard'

    export default {
        name: 'FollowUps',
        data () {
            return {
                isLoading: false,
                followUps: {
                    data: []
                }
            }
        },
        computed: {
            hasRegistry () {
                for (let line of this.followUps.data)
                    for (let i = 1; i < line.length; i++)
                        if (line[i] !== 0)
                            return true

                return false
            }
        },
        mounted () {
            this.initFollowUps()
        },
        methods: {
            initFollowUps () {
                this.isLoading = true

                getFollowUps()
                       .then(response => {
                           this.isLoading = false
                           this.followUps = response.data

                           c3.generate({
                               bindto: this.$refs.followUps,
                               data: {
                                   columns: this.followUps.data,
                                   type: 'spline'
                               },
                               axis: {
                                   x: {
                                       type: 'category',
                                       categories: this.followUps.period
                                   }
                               }
                           })
                       })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/components/widgets/FollowUps.vue